import { useState, useEffect } from "react";
import Draggable from "../components/Draggable";
import Header from "../components/Header";
import VariableTextCell from "../components/VariableTextCell";
import ListItem from "../components/ListItem";

import GetRandomGridTemplate from "../hooks/getRandomGridTemplate";

import professions from "../resources/professions.json";

function About({ headerPressed }) {
  const [lastTemplateIndex, setLastTemplateIndex] = useState(null);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [profession, setProfession] = useState(null);
  const [lastProfessionIndex, setLastProfessionIndex] = useState(null);

  useEffect(() => {
    setRandomTemplate();
    setRandomProfession();

    const professionInterval = setInterval(() => {
      setRandomProfession();
    }, 2000);
    return () => clearInterval(professionInterval);
  }, []);

  const setRandomTemplate = () => {
    const newTemplateInfo = GetRandomGridTemplate(lastTemplateIndex);
    setLastTemplateIndex(newTemplateInfo.index);
    setCurrentTemplate(newTemplateInfo.template);
  };

  const setRandomProfession = () => {
    let possibleProfessions = [];

    //so templates dont repeat
    for (let i = 0; i < professions.length; i++) {
      if (lastProfessionIndex !== i) {
        possibleProfessions.push(professions[i]);
      }
    }

    const randomIndex = Math.floor(Math.random() * possibleProfessions.length);

    setLastProfessionIndex(
      randomIndex >= lastProfessionIndex ? randomIndex + 1 : randomIndex
    );
    setProfession(possibleProfessions[randomIndex]);
  };

  const getGridArea = (styleIndex) => {
    return { gridArea: currentTemplate.styles[styleIndex] };
  };

  const personal = () => {
    const text = "Hi I'm João — a " + profession + ".";

    return (
      <div
        onClick={() => setRandomProfession()}
        className={`professionCell cell button`}
      >
        <VariableTextCell
          text={text}
          minFontSize={4}
          maxFontSize={2000}
          isBold={true}
        ></VariableTextCell>
      </div>
    );
  };

  const education = () => {
    return (
      <div className={`educationCell cell text-list`}>
        <span className="title text-body">I studied</span>
        <ListItem text="Design and Multimedia Masters @ Universidade de Coimbra"></ListItem>
        <ListItem text="Design and Multimedia Bachelors @ Universidade de Coimbra"></ListItem>
        <ListItem text="C1 Advanced English Certificate @ Cambridge"></ListItem>
      </div>
    );
  };

  const work = () => {
    return (
      <div className={`workCell cell text-list`}>
        <span className="title text-body">I worked as</span>
        <ListItem
          text="Frontend Designer, Frontend Developer @
          CISUC"
          children={[
            <ListItem text={'JavaScript'} />,
            <ListItem text={'ReactJS'} />,
            <ListItem text={'HTML'} />,
            <ListItem text={'CSS'} />,
            <ListItem text={'Sass'} />,
            <ListItem text={'Figma'} />,
          ]}
          rotationMultiplier={0.2}
        ></ListItem>

        <ListItem text="Design & Maketing Coordinator @ JEST"
          children={[
            <ListItem text={'Management'} />,
            <ListItem text={'Figma'} />,
            <ListItem text={'Adobe Creative Cloud'} />
          ]}
          rotationMultiplier={0.2}
        ></ListItem>

        <ListItem text="Design & Maketing Collaborator @ JEST"
          children={[
            <ListItem text={'Figma'} />,
            <ListItem text={'Adobe Creative Cloud'} />
          ]}
          rotationMultiplier={0.2}
          ></ListItem>

        <ListItem text="UI/UX Designer, Graphic Designer @ TEDx Universidade de Coimbra"
          children={[
            <ListItem text={'Figma'} />,
            <ListItem text={'Adobe Creative Cloud'} />
          ]}
          rotationMultiplier={0.2}
        ></ListItem>
      </div>
    );
  };

  const technologies = () => {
    return (
      <div className={`technologiesCell cell text-list`}>
        <span className="title text-body">I know</span>
        <ListItem text='Angular'></ListItem>
        <ListItem text='Adobe Creative Cloud'></ListItem>
        <ListItem text='C#'></ListItem>
        <ListItem text='CMS'></ListItem>
        <ListItem text='CSS'></ListItem>
        <ListItem text='Figma'></ListItem>
        <ListItem text='HTML'></ListItem>
        <ListItem text='Java'></ListItem>
        <ListItem text='JavaScript'></ListItem>
        <ListItem text='Processing'></ListItem>
        <ListItem text='Python'></ListItem>
        <ListItem text='ReactJS'></ListItem>
        <ListItem text='Sass'></ListItem>
        <ListItem text='Unity'></ListItem>
      </div>
    );
  };

  const contact = () => {
    return (
      <div className={"contactCell cell text-body"}>
        <a href="mailto:hey@joaocristovao.com">
          Reach out at
          hey@joaocristovao.com</a>
      </div>
    );
  };

  const socials = () => {
    return (
      <div className={`socialsCell cell`}>
        <a
          href={"https://github.com/JoaoMCristovao"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 98 96"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"
            />
          </svg>
        </a>

        <a
          href={"https://www.linkedin.com/in/joaomariacristovao"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 96 96"
          >
            <path d="m84.57,0H11.43C5.12,0,0,5.12,0,11.43v73.14c0,6.31,5.12,11.43,11.43,11.43h73.14c6.31,0,11.43-5.12,11.43-11.43V11.43c0-6.31-5.12-11.43-11.43-11.43ZM29.71,36.57v43.43h-13.71v-43.43h13.71Zm-13.71-12.64c0-3.2,2.74-5.65,6.86-5.65s6.7,2.45,6.86,5.65c0,3.2-2.56,5.78-6.86,5.78s-6.86-2.58-6.86-5.78Zm64,56.07h-13.71v-22.86c0-4.57-2.29-9.14-8-9.23h-.18c-5.53,0-7.82,4.71-7.82,9.23v22.86h-13.71v-43.43h13.71v5.85s4.41-5.85,13.28-5.85,16.43,6.24,16.43,18.88v24.55Z" />
          </svg>
        </a>
      </div>
    );
  };

  const website = () => {
    return (
      <div className="cell websiteCell text-list">
        <span>
          Website designed and developed using Figma, React.js and CMS.
        </span>
      </div>
    );
  };

  const resume = () => {
    return (
      <div className="cell resumeCell text-body">
        <span>
          <a href={"/resume.pdf"} download={"CV_JoaoCristovao"}>Download Resume</a>
        </span>
      </div>
    );
  };

  return (
    <>
      <Header headerPressed={headerPressed} isWork={false} />
      {currentTemplate && profession ? (
        <>
          {personal()}
          {education()}
          {work()}
          {technologies()}
          {contact()}
          {socials()}
          {resume()}
          {website()}
        </>
      ) : (
        <></>
      )}

      {Array.from({ length: 40 }, (_, index) => (
        <Draggable key={index}></Draggable>
      ))}
    </>
  );
}

export default About;
